module.exports = __webpack_public_path__ + "static/media/R2-D2.c8068fb5.jpg";